function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

// todo: use context from utils (add dependency)
var _ctx = getGlobal();

function getInstance(vendorKey, projectKey) {
  var instance = _ctx[vendorKey];
  return instance && (projectKey ? instance.getInstance(projectKey) : instance.getInstance());
}

function getGlobal() {
  if (typeof self !== 'undefined') {
    return self;
  }

  if (typeof window !== 'undefined') {
    return window;
  }

  if (typeof global !== 'undefined') {
    return global;
  }

  throw new Error('unable to locate global object');
}

function merge(defaults, target) {
  if (target === void 0) {
    target = {};
  }

  if (!defaults) return target;
  return _objectSpread({}, defaults, target);
}

function mergeDefaults(defaults, options) {
  if (!options || !defaults) return options;

  var _trackingOptions = defaults.trackingOptions,
      _rest = _objectWithoutPropertiesLoose(defaults, ["trackingOptions"]);

  var trackingOptions = options.trackingOptions,
      rest = _objectWithoutPropertiesLoose(options, ["trackingOptions"]);

  return _objectSpread({
    trackingOptions: merge(_trackingOptions, trackingOptions)
  }, merge(_rest, rest));
}

var AmplitudeAPI = function AmplitudeAPI(env) {
  var _this = this;

  _defineProperty(this, "env", void 0);

  _defineProperty(this, "getInstance", function () {
    return getInstance(AmplitudeAPI.vendorKey);
  });

  _defineProperty(this, "getScript", function () {
    return AmplitudeAPI.scripts[_this.env];
  });

  _defineProperty(this, "getFinalOptions", function (options) {
    return mergeDefaults(AmplitudeAPI.defaultAPIOptions, options);
  });

  _defineProperty(this, "init", function (options) {
    // todo: transform options => amplitude options
    var instance = _this.getInstance();

    return new Promise(function (resolve, reject) {
      if (!instance) reject();

      var _this$getFinalOptions = _this.getFinalOptions(options),
          apiKey = _this$getFinalOptions.apiKey,
          rest = _objectWithoutPropertiesLoose(_this$getFinalOptions, ["apiKey"]);

      instance.init(apiKey, undefined, rest, function () {
        return resolve();
      });
    });
  });

  _defineProperty(this, "track", function (userData, eventData) {
    var instance = _this.getInstance();

    return new Promise(function (resolve, reject) {
      if (!instance) reject();

      if (userData && Object.keys(userData).length > 0) {
        var userId = userData.userId,
            group = userData.group,
            userProps = _objectWithoutPropertiesLoose(userData, ["userId", "group"]);

        if (typeof userId !== 'undefined' && userId !== '') {
          // @ts-ignore
          instance.setUserId(userId);
        }

        if (Object.keys(userProps).length > 0) {
          instance.setUserProperties(userProps);
        }

        if (group) {
          instance.setGroup(group.groupType, group.groupName);
        }
      }

      if (eventData) {
        var eventName = eventData.eventName,
            rest = _objectWithoutPropertiesLoose(eventData, ["eventName"]);

        instance.logEvent(eventName, rest);
      }

      setTimeout(function () {
        return resolve();
      }, 10);
    });
  });

  _defineProperty(this, "getDeviceId", function () {
    var instance = _this.getInstance();

    return instance && instance.options.deviceId;
  });

  _defineProperty(this, "getSessionId", function () {
    var instance = _this.getInstance();

    return instance && instance.getSessionId();
  });

  _defineProperty(this, "clearUserProperties", function () {
    var instance = _this.getInstance();

    return instance && instance.clearUserProperties();
  });

  _defineProperty(this, "controlTracking", function (value) {
    var instance = _this.getInstance();

    if (!instance) return;
    instance.setOptOut(value);
  });

  _defineProperty(this, "terminateSession", function () {
    var instance = _this.getInstance();

    if (!instance) return; // @ts-ignore

    instance.setUserId(null); // @ts-ignore

    if (instance.resetSessionId !== undefined) instance.resetSessionId();
    instance.regenerateDeviceId();
  });

  this.env = env;
};

_defineProperty(AmplitudeAPI, "vendorKey", 'amplitude');

_defineProperty(AmplitudeAPI, "scripts", {
  development: [{
    src: 'https://cdn.amplitude.com/libs/amplitude-4.5.2.js'
  }],
  production: [{
    src: 'https://cdn.amplitude.com/libs/amplitude-4.5.2-min.js',
    integrity: 'sha384-f1maK8oMrCMNEWGGg3Hx3dMTOQBbXr4e1ZIjB/J0TcgJx5UeE0g5S5PM5BbWPe4E',
    crossOrigin: 'anonymous'
  }]
});

_defineProperty(AmplitudeAPI, "defaultAPIOptions", {
  logLevel: 'DISABLE',
  saveEvents: false,
  includeUtm: true,

  /* allow dma, os, platform, region, version_name */
  trackingOptions: {
    carrier: false,
    city: false,
    country: false,
    ip_address: false,
    language: false
  }
});

export { AmplitudeAPI, mergeDefaults };



//////////////////
// WEBPACK FOOTER
// ../@csod/tracker-vendor-amplitude/build/index.js
// module id = 632
// module chunks = 0